import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import WidgetCard from './WidgetCard'
import { PrimaryButton } from '../../../layout/styledComponents'

const Headline = styled.p`
  font-size: 22px;
  font-weight: 600;
  margin: 0 0 6px;
  color: ${(p) => p.theme?.color?.urgent || '#C24D49'};
`

const Sub = styled.p`
  margin: 0 0 18px;
  color: ${(p) => p.theme?.color?.inkMuted || '#6B7280'};
  font-size: 14px;
`

function formatAmount(minor, currency = 'INR') {
  const major = (minor || 0) / 100
  if (currency === 'INR') return `₹${major.toLocaleString('en-IN')}`
  if (currency === 'USD') return `$${major.toLocaleString('en-US', { minimumFractionDigits: 2 })}`
  return `${currency} ${major}`
}

export default function DuesCard({ data }) {
  const navigate = useNavigate()
  if (!data || !data.totalAmountMinor) return null
  return (
    <WidgetCard tone="urgent" title="Outstanding payment">
      <Headline>{data.headlineLabel || `${formatAmount(data.totalAmountMinor, data.currency)} due`}</Headline>
      <Sub>
        {data.itemCount > 1
          ? `${data.itemCount} items pending payment`
          : 'Pay now to continue your care plan without interruption.'}
      </Sub>
      <PrimaryButton onClick={() => navigate('/patient-home/shop/dues')}>
        Pay {formatAmount(data.totalAmountMinor, data.currency)}
      </PrimaryButton>
    </WidgetCard>
  )
}
